import axios, { CancelTokenSource } from 'axios';
import { Item } from '../../types/common';

interface ProhibitedItem extends Item {
  isProhibited: boolean;
}

interface Response {
  items: ProhibitedItem[];
  availableCouriers: string[] | null;
  excludedCouriers: string[];
}

let cancelToken: CancelTokenSource;

const determineProhibited = async (items: Item[]): Promise<Response> => {
  if (cancelToken !== undefined) {
    // cancel previous quotation request if any
    cancelToken.cancel();
  }

  cancelToken = axios.CancelToken.source();

  const response = await axios.post(
    '/api/items/prohibited',
    { items },
    { cancelToken: cancelToken.token },
  );
  return response.data?.data;
};

export default determineProhibited;
